import "./inputTextfield.scss";
import InputTextfield from "./InputTextfield";

export default InputTextfield;